var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"keuf",on:{"click":_vm.openKeFu}},[_c('i',{staticClass:"el-icon-service"})]),_vm._v(" "),_c('div',{staticClass:"wendang",on:{"click":_vm.openWenDang}},[_c('i',{staticClass:"el-icon-document"}),_vm._v("帮"),_c('br'),_vm._v("助"),_c('br'),_vm._v("引"),_c('br'),_vm._v("导"),_c('br')])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/helpOther.vue?vue&type=template&id=29069239&scoped=true&
// module id = null
// module chunks = 